import { render, staticRenderFns } from "./SettingsList.vue?vue&type=template&id=15988678&"
import script from "./SettingsList.vue?vue&type=script&lang=js&"
export * from "./SettingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports